<template>
    <Navbar></Navbar>
    <div class="product-detail-page">
        <div class="detail-banner">
            <div class="img-box detail-banner-img">
                <img src="/assets/product/transmission/9HDCT/9HDCT.jpg" alt="200-1-01">
            </div>
            <div class="detail-banner-r">
                
                <div class="detail-banner-t2">9HDCT 9速混动湿式双离合器自动变速器</div>
                <div class="detail-banner-desc transmission">
                    <div class="detail-desc">
                        <div>
                            集成高性能P2电机；<br />
                        </div>
                        <div>
                            低挡位更高的承载扭矩；<br />
                        </div>
                        <div>
                            更优的性能，效率和竞争优势。
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="detail-center">
            <div class="detail-center-l">

                <div class="one-titile">
                    核心配置
                </div>
                <div class="spec-row">
                    <div class="spec-image img-box">
                        <img src="/assets/product/transmission/9HDCT/9HDCT-1.jpg" alt="200-1-02">
                    </div>
                    <div class="spec-card">
                        <div class="spec-columns">
                            <div class="spec-title">
                                产品参数
                            </div>
                            <div class="spec-col">
                                <div class="spec-item">
                                    <div class="v">500N·m</div>
                                    <div class="k">扭矩容量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">9+R</div>
                                    <div class="k">挡位数量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">532*445*482</div>
                                    <div class="k">尺寸 X*Y*Z（mm）</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">103kg</div>
                                    <div class="k">重量</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">8.812</div>
                                    <div class="k">速比范围</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">电液控制系统</div>
                                    <div class="k">执行系统</div>
                                </div>
                                <div class="spec-item">
                                    <div class="v">120kW/330N·m</div>
                                    <div class="k">P2电机峰值性能</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
    <Footer></Footer>
</template>

<script setup>
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
</script>

<script>
export const pageConfig = {
    title: '9HDCT 9速混动湿式双离合器自动变速器 - 蜂巢汽车官网',
    keywords: '蜂巢,蜂巢汽车,发动机,变速器,电子',
    description: '蜂巢汽车科技集团有限公司，是一家掌握从传统动力到混合动力再到纯电动力（含控制器）全领域动力总成、汽车智能化集成系统等核心技术的零部件企业，具备完整的软、硬件产业链；能为客户提供高效节能环保的汽车动力总成、智能化出行解决方案',
    outputPath: 'transmission/9HDCT.html'
};

import { createApp } from 'vue';
import App from './9HDCT.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss";
import "@/assets/styles/transmission-200.scss";

function mountApp() {
    const appNode = document.getElementById('app');
    if (appNode) {
        if (appNode._vueApp) {
            appNode._vueApp.unmount();
            delete appNode._vueApp;
        }
        const app = createApp(App);
        app.use(store);
        appNode._vueApp = app.mount(appNode);
    }
}

document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
    module.hot.accept('./9HDCT.vue', () => {
        mountApp();
    });
}
</script>

<style lang="scss" scoped></style>
